import { ApiResponse } from '../../core/models/api-response.model';
import { EntityService } from '../../core/services/entity.service';
import { GlobalService } from '../../core/services/global.service';
import { Injectable } from '@angular/core';
import { Language } from '../language-selector/language.model';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { debug } from 'util';

@Injectable()
export class LanguageService {

  private areLanguagesLoaded = false;
  private languages: Language[] = [];
  private currentLanguage: Language = null;

  constructor(private http: GlobalService,
    private entityService: EntityService) {
  }

  getLanguages(): Observable<Language[]> {
    if (this.areLanguagesLoaded) {
      return Observable.of(this.languages);
    }

    const url = `languages`;
    return this.http.get(url)
      .map(res => this.entityService.extractData<Language[]>(res))
      .map(data => (data && data.map) ? data.map(dataItem => this.entityService.copy(dataItem, new Language())) : [])
      .map(languages => {
        this.languages = languages;
        this.loadCurrentLanguage();
        this.areLanguagesLoaded = true;

        return languages;
      });
  }

  getCurrentLanguage(): Observable<Language> {
    if (this.areLanguagesLoaded) {
      return Observable.of(this.currentLanguage);
    }
    return this.getLanguages().map(languages => this.currentLanguage);
  }

  resetCache() {
    this.areLanguagesLoaded = false;
  }

  changeLanguageTo(newLanguageId: number): Observable<Language> {
    const url = `languages/changeto/${newLanguageId}`;
    return this.http.post(url, null)
      .map(res => this.entityService.extractData<Language>(res))
      .map(data => this.entityService.copy(data, new Language()))
      .map(lang => { this.currentLanguage = lang; return lang; });
  }

  private loadCurrentLanguage() {
    this.currentLanguage = this.languages.find(l => l.isSelected);
    if (!this.currentLanguage) {
      this.currentLanguage = this.languages.length > 0 ? this.languages[0] : null;
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/services/language.service.ts